module.exports = __webpack_public_path__ + "img/DSC_0033.afbeb7e7.jpg";